module.exports = __webpack_public_path__ + "img/contacto_16-9.bbc2acd3.jpg";